import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "./ContainerCreate";
import { getArtist } from "../api/getArtist";

class ArtistContainer extends React.Component {
  componentDidMount() {
    const { artist } = this.props;
    //const decoded = decodeURIComponent(artist);
    //console.log("decoded:", decoded);
    this.props.request(artist);
  }

  render = () => {
    const { data, loading, failure, render } = this.props;
    const artist = (data && data.data) || {};
    let error = false;
    if (Object.keys(artist).length === 0) {
      error = true;
      console.log("error:", error);
    }
    return !loading && render({ artist, loading, failure: error || failure });
  };
}

ArtistContainer.propTypes = {
  artist: PropTypes.string.isRequired,
};

export default CreateContainer(getArtist, ArtistContainer);
